import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { rootRoute } from './root'
import { RouteError } from '@lunary/ui-web/screen-state'

export const indexRoute = createRoute({
  path: '/',
  getParentRoute: () => rootRoute,
  component: lazyRouteComponent(() => import('../features/today/page'), 'TodayPage'),
  errorComponent: RouteError,
})
